import { matches } from "@mantine/form";

export const toClikPhoneFormat = (phone: string) => phone.replace(/\D/g, "");

export const phoneMatcher = matches(
  /^([+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3,4}[-\s.]?[0-9]{3,6}|-)$/,
  "Phone must be a valid phone number"
);
